import React from 'react';

import Room from '../room';

import S1 from './images/Superior..jpg';
import S2 from './images/Superior.1.jpg';
import S3 from './images/Superior.5.jpg';
import S4 from './images/Superior.13.jpg';
import S5 from './images/Superior.14.jpg';
import S6 from './images/Superior.17.jpg';
import S7 from './images/Superior.19.jpg';
import S8 from './images/Superior.21.jpg';
import S9 from './images/Superior.26.jpg';

const Superior = () => {

  const images = [
    { original: S1, thumbnail: S1 },
    { original: S2, thumbnail: S2 },
    { original: S3, thumbnail: S3 },
    { original: S4, thumbnail: S4 },
    { original: S5, thumbnail: S5 },
    { original: S6, thumbnail: S6 },
    { original: S7, thumbnail: S7 },
    { original: S8, thumbnail: S8 },
    { original: S9, thumbnail: S9 },
  ]

  return (
    <Room title="Superior" images={images} capacity={4}>
      <p className="p-services">Distribuidas en todos los sectores del hotel, estas habitaciones ofrecen mayor comodidad, debido a su amplitud y al concepto de privilegiar lo funcional a lo estético.</p>
      <p className="p-services">Las habitaciones superiores tienen formato twin o con cama matrimonial.</p>
      <p className="p-services">Equipada con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default Superior;



// WEBPACK FOOTER //
// ./src/rooms/superior/index.js